import {AsyncAction} from '../asyncUtilsTypes';
import {UserBaseDTO} from 'hemwb-api';

export enum ModelDisplayViewersActions {
  FETCH = 'MODEL_DISPLAY_VIEWERS/FETCH',
}
export type ModelDisplayViewersAction = AsyncAction<ModelDisplayViewersActions.FETCH, UserBaseDTO[], [string]>;
